import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';
import styles from './UsersCreateModal.styles';
import { getIsVisibleModal, closeModal } from '../../../redux/store/ui/common';
import { useIntl } from 'react-intl';
import SingleCreateUsers from './SingleCreateUsers';

type PhoneReportModalProps = {
  visible?: boolean;
};

const UsersCreateModal: React.FC<PhoneReportModalProps> = ({ visible }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const _visible = useSelector(getIsVisibleModal('UsersCreateModal'));

  const handleCancel = () => {
    dispatch(closeModal('UsersCreateModal'));
  };

  return (
    <>
      <div>
        <Modal
          wrapClassName="add-users-wrapper"
          title={intl.formatMessage({
            id: 'fleetadmin.users.create.title',
          })}
          open={visible || _visible}
          width={520}
          style={{ top: 'calc(15%)' }}
          onCancel={handleCancel}
          footer={null}
        >
          <SingleCreateUsers />
        </Modal>
      </div>
      <style jsx global>
        {styles}
      </style>
    </>
  );
};

export default UsersCreateModal;
